<template>
  <div>
    <div
      v-for="(image, i) in images"
      :key="i"
      class="imageList"
      :style="'background-image:url('+image+')'"
    ></div>
    <div style="text-align:center;" class="imageList obj-field upload-wrapper">
      <input
        @change="catchFiles($event)"
        accept="image/*"
        fileUpload
        type="file"
        value="Upload Image"
        multiple
      />
      <progress v-show="loading"></progress>
      <p v-show="!loading" class="plus">+</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImageRefSet",
  props: ["slg", "fname", "value"],
  data() {
    return {
      loading: false,
      images: this.value || []
    };
  },
  methods: {
    catchFiles(e) {
      $.each(e.target.files, (i, e) => {
        this.fileUpload(e);
      });
    },
    fileUpload(file) {
      var storageRef = window.fs.ref(
        `${this.$parent.$parent.set.siteName}/${file.name}`
      );
      var uploader = storageRef.put(file);

      uploader.on(
        "state_changed",
        statusSnapshot => {
          this.loading = true;
        },
        err => {
          alert("error", err);
        },
        () => {
          uploader.snapshot.ref.getDownloadURL().then(downloadURL => {
            this.images.push(downloadURL);
            this.$emit("input", this.images);
            this.loading = false;
          });
        }
      );
    }
  },
  computed: {
    image() {
      return;
    }
  }
};
</script>

<style scoped>
.plus {
  color: #379bff;
  font-size: 40px;
  line-height: 21px;
}
.imageList {
  width: 60px;
  height: 60px;
  border-radius: 5px;
  display: inline-block;
  margin: 10px;
  background-position: center;
  background-size: contain;
}
.eraseimg {
  color: red;
  margin-top: -23px;
  font-size: 15px;
}
</style>